import { memo } from "react";

import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

type TableSkeletonProps = {
  columns: number;
  rows?: number;
  showActions?: boolean;
};

export const TableSkeleton = memo(function TableSkeleton({
  columns,
  rows = 5,
  showActions = false,
}: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow className="hover:bg-transparent" key={`table-skeleton-row-${i}`}>
          {Array.from({ length: columns }).map((_, j) => {
            // Different widths for different column types
            let skeletonWidth = "w-full";

            if (j === 0) {
              skeletonWidth = "w-20"; // ID/Code column
            } else if (j === columns - 1 && showActions) {
              skeletonWidth = "w-16"; // Actions column
            } else if (j === columns - 1) {
              skeletonWidth = "w-24"; // Status column
            } else if (j === columns - 2) {
              skeletonWidth = "w-32"; // Date column
            }

            return (
              <TableCell key={`table-skeleton-cell-${i}-${j}`}>
                <Skeleton className={`h-4 ${skeletonWidth}`} />
              </TableCell>
            );
          })}
        </TableRow>
      ))}
    </>
  );
});
